import { Routes } from '@angular/router';
import { invitationCompletionGuard, oauthAppGuard, reverseAuthGuard } from './app/guards/auth.guard';
import { devOnlyGuard } from './app/guards/dev-only.guard';
import { PrivacyPolicyPage } from './app/pages/privacy-policy/privacy-policy';
import { TermsOfServicePage } from './app/pages/terms-of-service/terms-of-service';
import { CookiePolicyPage } from './app/pages/cookie-policy/cookie-policy';
import { WhoWeArePage } from './app/pages/who-we-are/who-we-are';
import { ContactsPage } from './app/pages/contacts/contacts';
import { ChangelogPage } from './app/pages/changelog/changelog';
import { UseCaseDetailPage } from './app/pages/use-cases/use-case-detail';
import { PublicPageComponent } from './app/pages/public/public-page.component';
import { PublicLeadLandingPageComponent } from './app/pages/lead-landing/public-lead-landing-page.component';
import { publicLandingDomainGuard } from './app/guards/public-landing-domain.guard';

export const appRoutes: Routes = [
    {
        path: 'unauthorized',
        loadComponent: () => import('./app/pages/notfound/auth-error.component').then((m) => m.AuthErrorComponent)
    },
    {
        path: '',
        loadComponent: () => import('./app/pages/landing/landing').then((module) => module.Landing),
        canActivate: [reverseAuthGuard],
        pathMatch: 'full'
    },
    {
        path: 'webinar',
        loadComponent: () => import('./app/pages/webinar/webinars.page').then((module) => module.WebinarsPage)
    },
    { path: 'webinar-25-giugno', redirectTo: 'webinar', pathMatch: 'full' },
    { path: ':slug', component: PublicLeadLandingPageComponent, canMatch: [publicLandingDomainGuard] },
    { path: 'privacy-policy', component: PrivacyPolicyPage },
    { path: 'terms-of-service', component: TermsOfServicePage },
    { path: 'cookie-policy', component: CookiePolicyPage },
    { path: 'chi-siamo', component: WhoWeArePage },
    { path: 'contattaci', component: ContactsPage },
    { path: 'casi-uso/:slug', component: UseCaseDetailPage },
    { path: 'settori/:slug', component: PublicPageComponent, data: { publicKind: 'settore' } },
    { path: 'soluzioni/:slug', component: PublicPageComponent, data: { publicKind: 'soluzione' } },
    { path: 'guide/:slug', component: PublicPageComponent, data: { publicKind: 'guida' } },
    { path: 'confronti/:slug', component: PublicPageComponent, data: { publicKind: 'confronto' } },
    { path: 'l/:tenantSlug/:slug', component: PublicLeadLandingPageComponent },
    { path: 'changelog', component: ChangelogPage },
    {
        path: 'privacy-policy',
        loadComponent: () =>
            import('./app/pages/privacy-policy/privacy-policy').then((module) => module.PrivacyPolicyPage)
    },
    {
        path: 'terms-of-service',
        loadComponent: () =>
            import('./app/pages/terms-of-service/terms-of-service').then((module) => module.TermsOfServicePage)
    },
    {
        path: 'cookie-policy',
        loadComponent: () => import('./app/pages/cookie-policy/cookie-policy').then((module) => module.CookiePolicyPage)
    },
    {
        path: 'chi-siamo',
        loadComponent: () => import('./app/pages/who-we-are/who-we-are').then((module) => module.WhoWeArePage)
    },
    {
        path: 'contattaci',
        loadComponent: () => import('./app/pages/contacts/contacts').then((module) => module.ContactsPage)
    },
    {
        path: 'casi-uso/:slug',
        loadComponent: () => import('./app/pages/use-cases/use-case-detail').then((module) => module.UseCaseDetailPage)
    },
    {
        path: 'settori/:slug',
        loadComponent: () =>
            import('./app/pages/public/public-page.component').then((module) => module.PublicPageComponent),
        data: { publicKind: 'settore' }
    },
    {
        path: 'soluzioni/:slug',
        loadComponent: () =>
            import('./app/pages/public/public-page.component').then((module) => module.PublicPageComponent),
        data: { publicKind: 'soluzione' }
    },
    {
        path: 'guide/:slug',
        loadComponent: () =>
            import('./app/pages/public/public-page.component').then((module) => module.PublicPageComponent),
        data: { publicKind: 'guida' }
    },
    {
        path: 'confronti/:slug',
        loadComponent: () =>
            import('./app/pages/public/public-page.component').then((module) => module.PublicPageComponent),
        data: { publicKind: 'confronto' }
    },
    {
        path: 'changelog',
        loadComponent: () => import('./app/pages/changelog/changelog').then((module) => module.ChangelogPage)
    },
    {
        path: 'credit-reporting-preview',
        loadComponent: () =>
            import('./app/pages/credit-reporting/operator-report/pages/operator-report-page/operator-report-page.component').then(
                (module) => module.OperatorReportPageComponent
            ),
        canActivate: [devOnlyGuard],
        title: 'Anteprima report credito'
    },
    {
        path: 'credit-reporting-preview/:id/config',
        loadComponent: () =>
            import('./app/pages/credit-reporting/operator-report/pages/product-configuration-page/product-configuration-page.component').then(
                (module) => module.ProductConfigurationPageComponent
            ),
        canActivate: [devOnlyGuard],
        canDeactivate: [(component: { canDeactivate: () => boolean }) => component.canDeactivate()],
        title: 'Anteprima configurazione report credito'
    },
    {
        path: 'app',
        loadComponent: () => import('./app/layout/core/app.layout').then((module) => module.AppLayout),
        canActivate: [oauthAppGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./app/components/dashboard/dashboard').then((module) => module.Dashboard)
            },
            { path: 'referral-program', redirectTo: '', pathMatch: 'full' },
            { path: 'crm', loadChildren: () => import('./app/pages/crm/crm.routes') },
            { path: 'workspace', loadChildren: () => import('./app/pages/workspace/workspace.routes') },
            { path: 'report', loadChildren: () => import('./app/pages/reporting/reporting.routes') },
            {
                path: 'credit-reporting',
                loadChildren: () => import('./app/pages/credit-reporting/operator-report/operator-report.routes')
            },
            { path: 'analytics', loadChildren: () => import('./app/pages/analytics/analytics.routes') },
            {
                path: 'discover-modules',
                loadComponent: () =>
                    import('./app/pages/discover-modules/discover-modules-page.component').then(
                        (module) => module.DiscoverModulesPageComponent
                    ),
                title: 'Scopri di più'
            },
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
        ]
    },
    {
        path: 'invitation/complete',
        loadComponent: () =>
            import('./app/pages/auth/invitation-complete.component').then(
                (module) => module.InvitationCompleteComponent
            ),
        canActivate: [invitationCompletionGuard]
    },
    {
        path: 'verify-email',
        loadComponent: () =>
            import('./app/pages/auth/verify-email.component').then((module) => module.VerifyEmailComponent)
    },
    {
        path: 'calcolatore',
        loadChildren: () => import('./app/pages/internal/pricing-calculator/pricing-calculator.routes'),
        canActivate: [devOnlyGuard]
    },
    // Temporary compatibility redirect for stale bookmarks. The old onboarding
    // implementation has been removed and will be rebuilt independently.
    { path: 'onboarding', redirectTo: 'settings', pathMatch: 'full' },
    {
        path: 'settings',
        loadChildren: () => import('./app/pages/settings/settings.routes'),
        canActivate: [oauthAppGuard]
    },
    {
        path: 'portal/:token',
        loadComponent: () => import('./app/pages/portal/portal-page.component').then((m) => m.PortalPageComponent)
    },
    {
        path: 'verify/signature/:id/:proof',
        loadComponent: () =>
            import('./app/pages/signature-verification/signature-verification-page.component').then(
                (m) => m.SignatureVerificationPageComponent
            )
    },
    {
        path: 'compass-privacy',
        loadComponent: () =>
            import('./app/pages/compass-privacy/compass-privacy').then((module) => module.CompassPrivacy)
    },
    {
        path: 'notfound',
        loadComponent: () => import('./app/pages/notfound/notfound').then((module) => module.Notfound)
    },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes'), canActivate: [reverseAuthGuard] },
    { path: 'admin', loadChildren: () => import('./app/pages/admin/admin.routes') },
    { path: '**', redirectTo: '/notfound' }
];
